import useMediaQuery from '@mui/material/useMediaQuery';

import { mobileLandscapeWidth } from '~/styles';

export function useIsGreaterThanMobile(): boolean {
  const isGreaterThanMobile = useMediaQuery(`(min-width:${mobileLandscapeWidth})`);
  return isGreaterThanMobile;
}
